import styled from "styled-components";

const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;  
  padding: 12px;
`;

export default TabContainer;